
import React, { useState, useEffect, useRef } from "react";
import "./HistoryDashboard.css";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import DownloadIcon from '@mui/icons-material/Download'

import FileUploadIcon from '@mui/icons-material/FileUpload';

const HistoryDashboard = () => {
    const API_BASE = "https://api.waraq.co/waraq/api/v1";
    const [data, setData] = useState([])
    const [requestID, setRequestID] = useState(null)
    const [openRequests, setOpenRequests] = useState({});
    const [currentOpenRequestId, setCurrentOpenRequestId] = useState(null);
    const fileInputRefs = useRef({});
    const [selectedFiles, setSelectedFiles] = useState({});

    const getAuthHeaders = () => {
        const token = localStorage.getItem("jwtToken");
        return { Authorization: `${token}` };
    };

    const handleDownload = async (mediaId, name) => {
        try {


            let splitFileName = name.split('.com/')[1];

            const url = `${API_BASE}/media/download/${mediaId}`;
            const response = await axios.get(url, {
                headers: getAuthHeaders(),
                responseType: "blob",
            });

            const blob = response.data;
            const blobUrl = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = blobUrl;

            const contentDisposition = response.headers["content-disposition"];
            let fileName = splitFileName
            if (contentDisposition) {
                const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                if (match?.[1]) {
                    fileName = match[1].replace(/['"]/g, "");
                }
            }

            if (!fileName.includes(".")) {
                const contentType = response.headers["content-type"];
                const ext = contentType?.split("/")[1] || "bin";
                fileName = `${fileName}.${ext}`;
            }

            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error("Download failed:", error);
        }
    };

    const handleFileChange = async (event, rowId) => {
        const file = event.target.files?.[0];
        if (!file) return;

        try {
            setSelectedFiles((prev) => ({ ...prev, [rowId]: file }));

            const formData = new FormData();
            formData.append("file", file);

            const { data: uploadRes } = await axios.post(
                `${API_BASE}/media/upload`,
                formData,
                { headers: getAuthHeaders() }
            );

            const mediaId = uploadRes?.data?.id;
            if (!mediaId) throw new Error("Upload failed: No mediaId returned");

            const patchUrl = `${API_BASE}/translate/docs/${rowId}/final-translated-document`;
            const patchRes = await axios.patch(
                patchUrl,
                {},
                {
                    params: { mediaId: mediaId },
                    headers: getAuthHeaders(),
                }
            );

            // Pass false to update without closing
            getDocbyTransleterID(currentOpenRequestId, false)
        } catch (err) {
            const errorMsg = err?.response?.data?.data || err.message;
            console.error("Error when uploading template:", errorMsg);
        }
    };


    const handleIconClick = (rowId) => {
        if (fileInputRefs.current[rowId]) {
            fileInputRefs.current[rowId].click();
        }
    };


    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        try {
            return new Date(dateString).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: '2-digit'
            });
        } catch {
            return dateString;
        }
    };


    const getDocbyTransleterID = async (id, shouldToggle = true) => {
        setRequestID(id)
        try {

            const res = await axios.get(
                `https://api.waraq.co/waraq/api/v1/translate/docs?requestId=${id}`,
                { headers: getAuthHeaders() }
            );
            const translateDocs = res.data.data.map((doc) => ({
                id: doc.id,
                document: doc.documentUrl,
                documentId: doc.documentId,
                templateId: doc.templateId,
                templateUrl: doc.templateUrl,
                translatedDocumentId: doc.translatedDocumentId,
                translatedDocumentUrl: doc.translatedDocumentUrl,

                finalTranslatedDocumentId: doc.finalTranslatedDocumentId,
                finalTranslatedDocumentUrl: doc.finalTranslatedDocumentUrl,
                creationDate: doc.creationDate,
            }));

            // Update the documents data
            setOpenRequests((prev) => ({
                ...prev,
                [id]: translateDocs,
            }));

            // Only toggle open/close if shouldToggle is true
            if (shouldToggle) {
                setCurrentOpenRequestId((prevId) => 
                    prevId === id ? null : id
                );
            }
        } catch (err) {
            console.log('error when get translate doc by id ', err);
        }

    }

    const downloadAllDoc = async (id, name) => {
        try {
            const url = `${API_BASE}/translate/requests/${id}/download-documents`;
            const response = await axios.get(url, {
                headers: getAuthHeaders(),
                responseType: "blob",
            });

            const blob = response.data;
            const blobUrl = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = blobUrl;

            const contentDisposition = response.headers["content-disposition"];
            let fileName = `${name}.zip`;

            if (contentDisposition) {
                const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                if (match?.[1]) {
                    fileName = match[1].replace(/['"]/g, "");
                }
            }

            if (!fileName.includes(".")) {
                fileName = `${fileName}.zip`;
            }

            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            window.URL.revokeObjectURL(blobUrl);
        } catch (err) {
            console.log('error when download all the doc', err.response?.data?.data || err.message);
        }
    }


    const getAllHistory = async () => {
        try {
            const res = await axios.get(
                "https://api.waraq.co/waraq/api/v1/admin/translate/requests/history",
                { headers: getAuthHeaders() }
            );
            setData(res.data.data);
        } catch (err) {
            console.error("Can't get all the history admin", err);
        }
    };

    useEffect(() => {
        getAllHistory();

    }, [])

    return (
        <div className="dashboard-container">
            <h2 style={{ fontWeight: '400' }}>History Management</h2>
            {data.length == 0 ?

                <div style={{
                    textAlign: 'center',
                    padding: '40px',
                    margin: '40px 0',
                    color: '#666',
                    fontSize: '18px',
                }}>
                    No history found ...
                </div>
                : <>
                    {data.map((taskDetails, index) => (
                        <div key={taskDetails.id || index} style={{ marginBottom: "20px" }}>

                            <div
                                onClick={() => getDocbyTransleterID(taskDetails.id, true)}
                                className="task-row"
                                style={{
                                    cursor: "pointer",
                                    margin: "30px 0px",
                                    padding: "10px 30px",
                                    borderRadius: "12px",
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: '10px',
                                    border: "1px solid #000",
                                }}
                            >
                                <div style={{ flex: '1 1 50px', minWidth: '50px' }}>

                                    <strong>Client</strong>
                                    <br />
                                    {taskDetails.clientName
                                        ? `${taskDetails.clientName}`
                                        : taskDetails.clientName || "N/A"}
                                </div>
                                <div style={{ flex: '1 1 50px', minWidth: '50px' }}>

                                    <strong>Request Date</strong>
                                    <br />
                                    {formatDate(taskDetails.requestDate)}
                                </div>
                                <div style={{ flex: '1 1 50px', minWidth: '50px' }}>

                                    <strong>Task Title</strong>
                                    <br />
                                    {taskDetails.taskTitle ||
                                        taskDetails.taskTitle ||
                                        `N/A`}
                                </div>

                                <div style={{ flex: '1 1 50px', minWidth: '50px' }}>
                                    <strong>Total Pages</strong>
                                    <br />
                                    {taskDetails.totalPages || "N/A"}
                                </div>
                                <div style={{ flex: '1 1 50px', minWidth: '50px' }}>
                                    <strong>Translator</strong>
                                    <br />
                                    {taskDetails.translatorName
                                        ? `${taskDetails.translatorName}`
                                        : taskDetails.translatorName || "N/A"}
                                </div>
                                <div style={{ flex: '1 1 50px', minWidth: '50px' }}>
                                    <strong>Proofreader</strong>
                                    <br />
                                    {taskDetails.proofreaderName
                                        ? `${taskDetails.proofreaderName}`
                                        : taskDetails.proofreaderName || "N/A"}
                                </div>
                                <div style={{ flex: '1 1 50px', minWidth: '50px' }}>
                                    <strong>Delivery Date</strong>
                                    <br />
                                    {formatDate(taskDetails.deliveryDate)}
                                </div>
                                <div style={{ flex: '1 1 50px', minWidth: '50px' }}>
                                    <strong style={{ fontSize: '14px' }}>Status</strong>
                                    <br />
                                    <span style={{ padding: "6px 16px", borderRadius: '20px', fontSize: '14px', fontWeight: '500', color: "#000", backgroundColor: "#C7DDFF" }} className="">
                                        {taskDetails.status || "Unknown"}
                                    </span>
                                </div>

                                <div style={{ flex: '1 1 50px', minWidth: '50px' }}>
                                    <strong style={{ fontSize: '14px' }}>Download All</strong>
                                    <br />
                                    <div style={{ marginLeft: '20px' }} onClick={(e) => {
                                        e.stopPropagation();
                                        downloadAllDoc(taskDetails.id, taskDetails.taskTitle)
                                    }}>

                                        <DownloadIcon />
                                    </div>
                                </div>



                            </div>

                            {currentOpenRequestId === taskDetails.id && openRequests[taskDetails.id] && (
                                <>
                                    <table
                                        className="styled-table"
                                        style={{ marginTop: "10px", width: "100%" }}
                                    >
                                        <thead className="styled-thead">
                                            <tr>
                                                <th style={{ fontWeight: '500', color: "#000", fontSize: '14px' }}> Document (PDF)</th>
                                                <th style={{ fontWeight: '500', color: "#000", fontSize: '14px' }}>Template (Word)</th>
                                                <th style={{ fontWeight: '500', color: "#000", fontSize: '14px' }}>Translation (Word)</th>
                                                <th style={{ fontWeight: '500', color: "#000", fontSize: '14px' }}>Delivery (Word)</th>
                                                <th style={{ fontWeight: '500', color: "#000", fontSize: '14px' }}>Created At</th>

                                            </tr>
                                        </thead>
                                        <tbody className="styled-tbody">
                                            {openRequests[taskDetails.id].map((row, idx) => (
                                                <tr className="styled-row" key={idx}>
                                                    <td
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            alignItems: "center",
                                                        }}
                                                        className="styled-cell"
                                                    >
                                                        <a
                                                            onClick={() => handleDownload(row.documentId, row.document)}
                                                            target="_blank"
                                                            style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
                                                            rel="noopener noreferrer"
                                                        >
                                                            {row?.document.split('.com/')[1]?.length > 25
                                                                ? row?.document.split('.com/')[1].slice(0, 25) + '...'
                                                                : row?.document.split('.com/')[1]}
                                                        </a>

                                                    </td>

                                                    <td className="styled-cell">
                                                        {row.templateUrl ? (
                                                            <a
                                                                onClick={() => handleDownload(row.templateId, row.templateUrl)}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
                                                            >

                                                                {row?.templateUrl.split('.com/')[1]?.length > 25
                                                                    ? row?.templateUrl.split('.com/')[1].slice(0, 25) + '...'
                                                                    : row?.templateUrl.split('.com/')[1]}
                                                            </a>
                                                        ) : (
                                                            "No template uploaded"
                                                        )}
                                                    </td>

                                                    <td className="styled-cell">

                                                        {row.translatedDocumentUrl ? (
                                                            <a
                                                                onClick={() => handleDownload(row.translatedDocumentId, row.translatedDocumentUrl)}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
                                                            >

                                                                {row?.translatedDocumentUrl.split('.com/')[1]?.length > 25
                                                                    ? row?.translatedDocumentUrl.split('.com/')[1].slice(0, 25) + '...'
                                                                    : row?.translatedDocumentUrl.split('.com/')[1]}
                                                            </a>
                                                        ) : (
                                                            !selectedFiles[row.id] && (
                                                                <FileUploadIcon
                                                                    style={{ fontSize: "16px", cursor: "pointer" }}
                                                                    onClick={() => handleIconClick(row.id)}
                                                                />
                                                            )
                                                        )}
                                                    </td>

                                                    <td>

                                                        <input
                                                            type="file"
                                                            ref={el => fileInputRefs.current[row.id] = el}
                                                            style={{ display: 'none' }}
                                                            onChange={(e) => handleFileChange(e, row.id)}
                                                            accept="*/*"
                                                        />

                                                        {row.finalTranslatedDocumentUrl ? (
                                                            <a
                                                                onClick={() => handleDownload(row.finalTranslatedDocumentId, row.finalTranslatedDocumentUrl)}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
                                                            >

                                                                {row?.finalTranslatedDocumentUrl.split('.com/')[1]?.length > 25
                                                                    ? row?.finalTranslatedDocumentUrl.split('.com/')[1].slice(0, 25) + '...'
                                                                    : row?.finalTranslatedDocumentUrl.split('.com/')[1]}
                                                            </a>
                                                        ) : (
                                                            !selectedFiles[row.id] && (
                                                                <FileUploadIcon
                                                                    style={{ fontSize: "16px", cursor: "pointer" }}
                                                                    onClick={() => handleIconClick(row.id)}
                                                                />
                                                            )
                                                        )}


                                                    </td>
                                                    <td className="styled-cell">
                                                        {row?.creationDate?.substring(0, 10) || "—"}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>


                                </>
                            )}
                        </div>
                    ))}
                </>}

        </div>
    );
};

export default HistoryDashboard;